import React, { useMemo } from 'react'
import { useAtom } from 'jotai'
import { withdrawStTokenModalIsOpenAtom, withdrawStTokenAmountAtom } from '@/page-components/Stake/atoms'
import { StepperProvider, StepperModal, useStepper } from '@/components'
import { useWithdrawStToken } from './WithdrawStTokenContext'
import { WithdrawStTokenStepOne } from './WithdrawStTokenStepOne'
import { WithdrawStTokenStepTwo } from './WithdrawStTokenStepTwo'
import { useSelectedDenom } from '../../../contexts/denom'
import { CHAIN_INFO_LIST } from '@/config'
import { formatMicroDenom } from '@/wallet-utils'

const WithdrawStTokenModal: React.FC = () => {
  const {
    resetWithdrawStTokenState,
    signWithdrawStTokenError,
    isBroadcastingWithdrawStToken,
    broadcastWithdrawStTokenError,
    ibcStatusError,
    isIbcStatusLoading
  } = useWithdrawStToken()

  const [isOpen, setIsOpen] = useAtom(withdrawStTokenModalIsOpenAtom)

  const [amount, setAmount] = useAtom(withdrawStTokenAmountAtom)

  const [denom] = useSelectedDenom()

  const chainInfo = CHAIN_INFO_LIST[denom]

  const formattedAmount = `${formatMicroDenom(amount, chainInfo.stakeCurrency.coinMinimalDenom, 5)} st${denom}`

  const steps = useMemo(() => {
    return ['Approve transfer in wallet', `Transfer st${denom}`]
  }, [denom])

  const handleClose = () => {
    setIsOpen(false)
    setAmount('0')
    resetWithdrawStTokenState()
  }

  const stepper = useStepper({
    steps,
    warning: isIbcStatusLoading,
    error: Boolean(signWithdrawStTokenError || broadcastWithdrawStTokenError || ibcStatusError),
    isOpen,
    isLoading: isBroadcastingWithdrawStToken || isIbcStatusLoading,
    isPostError: false,
    isComplete: false,
    onClose: handleClose
  })

  return (
    <StepperProvider {...stepper}>
      <StepperModal title="Withdraw" amount={formattedAmount}>
        <WithdrawStTokenStepOne />
        <WithdrawStTokenStepTwo />
      </StepperModal>
    </StepperProvider>
  )
}

export { WithdrawStTokenModal }
